import React from 'react';
import './About.css';
import { StarIcon } from '../StarIcon';
import { SettingsIcon } from '../SettingsIcon';
import { MessageCircleIcon } from '../MessageCircleIcon';
import { ZapIcon } from '../ZapIcon';
import { BlocksIcon } from '../BlocksIcon';
import { BoltIcon } from '../BoltIcon';

const About = () => {
  const features = [
    {
      title: 'OUR VISION',
      description: 'We aim to deliver packaging solutions that insure our customer\'s products are packaged and delivered in an optimized manner along with minimalizing environmental impact. We also specialize in providing one point packaging solutions for our clients. We work with the philosophy of building long-term relations with our clients to provide products of the highest quality and complete customer satisfaction.',
      icon: <StarIcon size={32} />
    },
    {
      title: 'OUR MISSION',
      description: 'Achieving customer satisfaction through our service and quality and also proactively interacting to find customer\'s unidentified packaging requirements and suggesting the packaging solutions for customer.',
      icon: <ZapIcon size={32} />
    },
    {
      title: 'OUR CORE VALUES',
      description: 'Passionate for customers satisfaction • Business Excellence • Integrity, Ownership, Enthusiasm & Sense of Belonging • Quality Assurance',
      icon: <StarIcon size={32} />
    }
  ];

  const processSteps = [
    { title: 'Packaging Design', icon: <BlocksIcon size={24} /> },
    { title: 'Packaging Audit', icon: <SettingsIcon size={24} /> },
    { title: 'Packaging Testing', icon: <BoltIcon size={24} /> },
    { title: 'Pilot Trials', icon: <SettingsIcon size={24} /> },
    { title: 'Implementations', icon: <StarIcon size={24} /> },
    { title: 'End to End Customer Feedback', icon: <MessageCircleIcon size={24} /> }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-header">
          <h2 className="section-title">About Us</h2>
          <p className="section-intro">
            Your trusted partner for industrial packaging and shipping solutions worldwide
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card fade-in">
              <div className="feature-icon-wrapper">
                <div className="feature-icon">{feature.icon}</div>
              </div>
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="process-section">
          <h3 className="process-title">Bring Sustainability to the core of your growth journey.</h3>
          <div className="process-circle">
            <div className="process-center">
              <div className="company-logo">OI</div>
              <div className="company-name">Octopus<br/>Industries</div>
            </div>
            {processSteps.map((step, index) => (
              <div key={index} className={`process-step step-${index + 1}`}>
                <div className="process-icon">{step.icon}</div>
                <div className="process-label">{step.title}</div>
              </div>
            ))}
            <svg className="process-connections" viewBox="0 0 400 400">
              <circle cx="200" cy="200" r="180" fill="none" stroke="#00494D" strokeWidth="2" strokeDasharray="5,5" opacity="0.3"/>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
